import { render, staticRenderFns } from "./WarningButtons.vue?vue&type=template&id=7e1b7d74&scoped=true"
import script from "./WarningButtons.vue?vue&type=script&lang=js"
export * from "./WarningButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1b7d74",
  null
  
)

export default component.exports